<template>
  <div class="otherCustomerOrders">
    <v-select style="width:280px;float:right;" v-if="orders" label="order_group_id" :options="orders" @input="changeOrder" v-model="$store.state.currentOrder">
      <template slot="option" slot-scope="option">
        {{option['as400_log_number']}} - {{option['program_name']}}
      </template>
      <template slot="selected-option" slot-scope="option">
        {{ option.as400_log_number }} - {{option.program_name}}
      </template>
    </v-select>
    <label id="customerLabel" style="float:right;padding-top:5px;padding-right:10px;" v-if="orders">Customer's Other Orders: </label>
  </div>
</template>
<script>
var methods = {}

methods.getOrders = function () {
  const postData = {
    customer: this.$store.state.currentOrder
  }
  axios.post(this.$apiAdress + '/api/orders/getOtherCustomerOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.orders = response.data
  })
}

methods.changeOrder = function (newVal) {
  this.$router.push('/order/' + newVal.order_id + '/' + newVal.order_group_id)
}

export default {
  // ===Component name
  name: "OtherCustomerOrders",
  // ===Props passed to component
  props: [],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        orders: null,
        selected: ''
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getOrders()
    // this.selected = this.current
  },
  watch: {
    // '$store.state.currentOrder': function (newVal, oldVal) {
    //   console.log('current new order')
    //   console.log(newVal)
    //   if (newVal) {
    //     if (this.selected) {
    //       if (this.selected.customer_number !== newVal.customer_number) {
    //         this.getOrders()
    //         this.selected = newVal
    //       }
    //     } else {
    //       this.getOrders()
    //       this.selected = newVal
    //     }
    //   }
    // },
    'selected': function (newVal, oldVal) {
      if (newVal && oldVal) {
        this.$router.push('/order/' + newVal.order_id + '/' + newVal.order_group_id)
      }
    }
  },
  // ===Computed properties for the component
  computed: {

  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .otherCustomerOrders {
    position:fixed;
    top:65px;
    z-index:1030;
    right:5px;
    width:500px;
  }

  #customerLabel {
    display: block;
  }
  @media(max-width: 576px) {
    .otherCustomerOrders {
      top:113px !important;
    }
  }

  @media(max-width: 700px) {
    #customerLabel {
      display: none;
    }
  }
</style>
